import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "6edfc308-bb25-4308-80ae-301a001126f7", content: "1.4 mV", options: {} },
  { id: "0f0f590e-4e9a-4c86-a7aa-5ad4770183f4", content: "2.3 mV", options: {} },
  { id: "dc764d13-6999-44f5-9472-903c8a8a46ca", content: "3.2 mV", options: {} },
  { id: "85a79b03-3aaf-4251-8750-a75389bcf1c8", content: "1.4 V", options: {} },
  { id: "d3f1b058-e33d-4587-b4bf-95ccfd127201", content: "3.3 V", options: {} },
  { id: "8b84d20f-6c2e-4e86-803d-39325bdffbac", content: "3.2 V", options: {} },
];

export const task: Task = {
  id: "5b1e4db6-baab-4c63-a939-daaf9591fddd",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["0f0f590e-4e9a-4c86-a7aa-5ad4770183f4"],
};
